const menu = [
  {
    title: 'Overview',
    icon: 'heroicons:presentation-chart-line',
    name: 'website',
    type: 'only',
    role: 'homes',
  },
  {
    title: 'Catalogs',
    icon: 'system-uicons:tags',
    name: 'website.catalog',
    type: 'only',
    role: 'catalogs',
  },
  {
    title: 'Feeds',
    icon: 'fluent:feed-24-regular',
    name: 'website.feeds',
    status: false,
    type: 'many',
    role: 'feeds',
    children: [
      {
        title: 'Facebook Catalog',
        name: 'website.feeds',
        role: 'feeds',
      },
      {
        title: 'Product Feeds',
        name: 'website.product-feeds-v2',
        role: 'feeds',
      },
    ],
  },
  {
    title: 'Products',
    icon: 'fluent:tag-28-regular',
    name: 'website.products',
    status: false,
    type: 'many',
    role: 'products',
    children: [
      {
        title: 'All Products',
        name: 'website.products',
        role: 'products',
      },
      {
        title: 'Collections',
        name: 'website.collections',
        role: 'products',
      },
      // {
      //   title: 'Inventory',
      //   name: 'website.inventory',
      //   role: 'products',
      // },
      // {
      //   title: 'Product Feeds',
      //   name: 'website.product-feeds',
      //   role: 'products',
      // },
      {
        title: 'Personalized  Product',
        name: 'website.product-personalized',
        role: 'products',
      },
      // {
      //   title: 'Bulk Updates',
      //   name: 'website.bulkupdates',
      //   role: 'products',
      // },
      // {
      //   title: 'Product Options',
      //   name: 'website.menufilter',
      //   role: 'products',
      // },
      {
        title: 'Gem Pages',
        name: 'website.products.gemPages',
        role: 'products',
      },
      // {
      //   title: 'Reviews',
      //   name: 'website.apps.product-review.list',
      //   role: 'products',
      // },
      // {
      //   title: 'Test componet',
      //   name: 'website.products.dattest',
      // },
    ],
  },
  {
    title: 'Orders',
    icon: 'fluent:receipt-32-regular',
    name: 'website.orders',
    status: false,
    type: 'many',
    role: 'orders',
    children: [
      {
        title: 'All Orders',
        name: 'website.orders',
        role: 'orders',
      },
      {
        title: 'Abandoned Checkouts',
        name: 'website.abandoned',
        role: 'orders',
      },
    ],
  },
  // {
  //   title: 'Catalog',
  //   icon: 'mdi-tag-multiple ',
  //   name: 'website.catalog',
  //   status: false,
  //   type: 'many',
  //   role: 'products',
  //   children: [
  //     {
  //       title: 'Catalog',
  //       name: 'website.catalog',
  //       role: 'products',
  //     },
  //     {
  //       title: 'Import list',
  //       name: 'website.import-list',
  //       role: 'products',
  //     },
  //   ],
  // },
  {
    title: 'Analytics',
    icon: 'heroicons:chart-bar',
    name: 'website.analytics',
    status: false,
    type: 'many',
    role: 'analystics',
    children: [
      {
        title: 'Analytics',
        name: 'website.analytics',
        role: 'analystics',
      },
      {
        title: 'Sales Reports',
        name: 'website.sales-reports',
        role: 'analystics',
      },
      {
        title: 'Estimated Profit',
        name: 'website.estimated-profit',
        role: 'analystics',
      },
      {
        title: 'Ads Fee',
        name: 'website.add-fee',
        role: 'analystics',
      },
      {
        title: 'UTM Analytics',
        name: 'website.utm-analystics',
        role: 'analystics',
      },
      {
        title: 'Live View',
        name: 'website.live-view',
        role: 'live_view',
      },
    ],
  },
  // {
  //   title: 'Pixel',
  //   icon: 'ph:code-block',
  //   status: false,
  //   type: 'many',
  //   role: 'report',
  //   name: 'website.pixel.sharePixel',
  //   children: [
  //     {
  //       title: 'Share Pixel',
  //       name: 'website.pixel.sharePixel',
  //       role: 'settings',
  //     },
  //   ],
  // },
  {
    title: 'Discounts',
    icon: 'streamline:discount-percent-coupon',
    status: false,
    type: 'many',
    role: 'discounts',
    name: 'website.discount.code',
    children: [
      {
        title: 'Code',
        name: 'website.discount.code',
        role: 'discounts',
      },
      {
        title: 'Automatic',
        name: 'website.discount.automatic',
        role: 'discounts',
      },
    ],
  },
  {
    title: 'GMC',
    icon: 'mdi-google',
    name: 'website.gmc',
    status: false,
    type: 'many',
    role: 'gmc',
    children: [
      {
        title: 'GMC Catalogs',
        name: 'website.gmc.catalogs',
        role: 'gmc',
      },
      {
        title: 'Sync Collections',
        name: 'website.gmc.sync-collections',
        role: 'gmc',
      },
      {
        title: 'Product Feeds',
        name: 'website.gmc.product-feeds',
        role: 'gmc',
      },
    ],
  },
  // {
  //   title: 'Customer',
  //   icon: 'solar:user-id-outline',
  //   name: 'website.customer',
  //   children: [],
  //   role: 'customers',
  //   type: 'only',
  // },
  // {
  //   title: 'Apps',
  //   icon: 'fluent:apps-48-regular',
  //   name: 'website.apps',
  //   type: 'only',
  //   role: 'apps',
  // },
  {
    title: 'Settings',
    icon: 'heroicons:cog-6-tooth',
    name: 'website.settings',
    children: [],
    type: 'only',
    role: 'settings',
  },
  // {
  //   title: 'Payout',
  //   icon: 'mynaui:credit-card',
  //   name: 'website.settings.payout',
  //   children: [],
  //   type: 'only',
  //   role: 'settings',
  // },
  {
    title: 'Sales Channel',
    icon: 'iconoir:megaphone',
    name: 'website.sales-channel',
    type: 'only',
    role: 'settings',
  },
  {
    title: 'Online Store',
    icon: 'carbon:store',
    status: false,
    type: 'many',
    role: 'online_store',
    children: [
      {
        title: 'Themes',
        name: 'website.settings.themes',
        role: 'checkout',
      },
      {
        title: 'Custom Store',
        name: 'website.themes',
        role: 'online_store',
      },
      // {
      //   title: 'Custom Homepage',
      //   name: 'website.custom-homepage',
      //   role: 'online_store',
      // },
      {
        title: 'Pages',
        name: 'website.pages',
        role: 'online_store',
      },
      {
        title: 'Navigation',
        name: 'website.menus',
        role: 'online_store',
      },
      {
        title: 'Domain',
        name: 'website.domain',
        role: 'online_store',
      },
      {
        title: 'Preferences',
        name: 'website.preferences',
        role: 'online_store',
      },
      // {
      //   title: 'Member',
      //   icon: 'mdi-account-group',
      //   name: 'website.member',
      //   type: 'only',
      //   role: 'online_store',
      // },
      // {
      //   title: 'Size chart',
      //   name: 'website.sizechart',
      //   role: 'online_store',
      // },
    ],
  },
  // {
  //   title: 'Seller',
  //   icon: 'mdi-account-group',
  //   name: 'website.seller',
  //   children: [],
  //   type: 'only',
  //   role: 'seller',
  // },
];

const dropMenu = [
  {
    title: 'Overview',
    icon: 'heroicons:presentation-chart-line',
    name: 'website',
    type: 'only',
    role: 'homes',
  },
  {
    title: 'Orders',
    icon: 'fluent:receipt-32-regular',
    name: 'website.orders',
    type: 'only',
    role: 'orders',
  },
  {
    title: 'Catalogs',
    icon: 'system-uicons:tags',
    name: 'website.catalog',
    type: 'only',
    role: 'catalogs',
  },
  {
    title: 'Products',
    icon: 'fluent:tag-28-regular',
    name: 'website.products',
    status: false,
    type: 'many',
    role: 'products',
    children: [
      {
        title: 'All Products',
        name: 'website.products',
        role: 'products',
      },
      {
        title: 'Collections',
        name: 'website.collections',
        role: 'products',
      },
      {
        title: 'Gem Pages',
        name: 'website.products.gemPages',
        role: 'products',
      },
      // {
      //   title: 'Inventory',
      //   name: 'website.inventory',
      //   role: 'products',
      // },
      // {
      //   title: 'Product Feeds',
      //   name: 'website.product-feeds',
      //   role: 'products',
      // },
      // {
      //   title: 'Personalized  Product',
      //   name: 'website.product-personalized',
      //   role: 'products',
      // },
      // {
      //   title: 'Bulk Updates',
      //   name: 'website.bulkupdates',
      //   role: 'products',
      // },
      // {
      //   title: 'Product Options',
      //   name: 'website.menufilter',
      // },
    ],
  },
  {
    title: 'Analytics',
    icon: 'heroicons:chart-bar',
    name: 'website.analytics',
    status: false,
    type: 'many',
    role: 'analystics',
    children: [
      // {
      //   title: 'Analytics',
      //   name: 'website.analytics',
      //   role: 'dashboards',
      // },
      {
        title: 'Sales Reports',
        name: 'website.sales-reports',
        role: 'analystics',
      },
      {
        title: 'Estimated Profit',
        name: 'website.estimated-profit',
        role: 'analystics',
      },
      {
        title: 'Ads Fee',
        name: 'website.add-fee',
        role: 'analystics',
      },
      {
        title: 'UTM Analytics',
        name: 'website.utm-analystics',
        role: 'analystics',
      },
      {
        title: 'Live View',
        name: 'website.live-view',
        role: 'live_view',
      },
    ],
  },
  {
    title: 'Share Pixel',
    icon: 'ph:code-block',
    status: false,
    type: 'many',
    role: 'settings',
    name: 'website.pixel.sharePixel',
  },
  {
    title: 'Discounts',
    icon: 'heroicons:receipt-percent',
    status: false,
    type: 'many',
    role: 'discounts',
    name: 'website.discount.code',
    children: [
      {
        title: 'Code',
        name: 'website.discount.code',
        role: 'discounts',
      },
      {
        title: 'Automatic',
        name: 'website.discount.automatic',
        role: 'discounts',
      },
    ],
  },
  // {
  //   title: 'Customers',
  //   icon: 'heroicons:users',
  //   name: 'website.customer',
  //   children: [],
  //   role: 'customers',
  //   type: 'only',
  // },
  {
    title: 'Boost UpSell',
    icon: 'mdi:tag-arrow-up-outline',
    name: 'website.upsell',
    type: 'only',
    role: 'apps',
  },
  // {
  //   title: 'Boost UpSell',
  //   icon: 'mdi:tag-arrow-up-outline',
  //   name: 'website.upsell',
  //   type: 'only',
  //   role: 'apps',
  // },
  {
    title: 'Settings',
    icon: 'heroicons:cog-6-tooth',
    name: 'website.settings',
    children: [],
    type: 'only',
    role: 'settings',
  },
  {
    title: 'Payouts',
    icon: 'mynaui:credit-card',
    name: 'website.settings.payout',
    children: [],
    type: 'only',
    role: 'settings',
  },
  {
    title: 'Notifications',
    icon: 'ri-telegram-line',
    name: 'website.notification',
    type: 'only',
    role: 'settings',
  },
  {
    title: 'Sales Channel',
    icon: 'iconoir:megaphone',
    name: 'website.sales-channel',
    type: 'only',
    role: 'settings',
  },
  {
    title: 'Online Store',
    icon: 'carbon:store',
    status: false,
    type: 'many',
    role: 'online_store',
    children: [
      {
        title: 'Themes',
        name: 'website.settings.themes',
        role: 'checkout',
      },
      {
        title: 'Custom Store',
        name: 'website.themes',
        role: 'online_store',
      },
      // {
      //   title: 'Custom Homepage',
      //   name: 'website.custom-homepage',
      //   role: 'online_store',
      // },
      {
        title: 'Pages',
        name: 'website.pages',
        role: 'online_store',
      },
      {
        title: 'Navigation',
        name: 'website.menus',
        role: 'online_store',
      },
      {
        title: 'Domain',
        name: 'website.domain',
        role: 'online_store',
      },
      {
        title: 'Preferences',
        name: 'website.preferences',
        role: 'online_store',
      },
      // {
      //   title: 'Member',
      //   icon: 'mdi-account-group',
      //   name: 'website.member',
      //   type: 'only',
      //   role: 'online_store',
      // },
      // {
      //   title: 'Size chart',
      //   name: 'website.sizechart',
      //   role: 'online_store',
      // },
    ],
  },
];
const podMenu = [
  {
    title: 'Overview',
    icon: 'heroicons:presentation-chart-line',
    name: 'website',
    type: 'only',
    role: 'homes',
  },
  {
    title: 'Orders',
    icon: 'fluent:receipt-32-regular',
    name: 'website.orders',
    status: false,
    type: 'only',
    role: 'orders',
    children: [
      {
        title: 'All Orders',
        name: 'website.orders',
        role: 'orders',
      },
      {
        title: 'Abandoned Checkouts',
        name: 'website.abandoned',
        role: 'orders',
      },
    ],
  },
  {
    title: 'Products',
    icon: 'fluent:tag-28-regular',
    name: 'website.products',
    status: false,
    type: 'many',
    role: 'products',
    children: [
      {
        title: 'All Products',
        name: 'website.products',
        role: 'products',
      },
      {
        title: 'Collections',
        name: 'website.collections',
        role: 'products',
      },
      // {
      //   title: 'Inventory',
      //   name: 'website.inventory',
      //   role: 'products',
      // },
      // {
      //   title: 'Product Feeds',
      //   name: 'website.product-feeds',
      //   role: 'products',
      // },
      {
        title: 'Personalized  Product',
        name: 'website.product-personalized',
        role: 'products',
      },
      // {
      //   title: 'Bulk Updates',
      //   name: 'website.bulkupdates',
      //   role: 'products',
      // },
      // {
      //   title: 'Product Options',
      //   name: 'website.menufilter',
      //   role: 'products',
      // },
    ],
  },
  {
    title: 'Analytics',
    icon: 'heroicons:chart-bar',
    name: 'website.analytics',
    status: false,
    type: 'many',
    role: 'analystics',
    children: [
      {
        title: 'Sales Reports',
        name: 'website.sales-reports',
        role: 'analystics',
      },
      {
        title: 'UTM Analytics',
        name: 'website.utm-analystics',
        role: 'analystics',
      },
      {
        title: 'Live View',
        name: 'website.live-view',
        role: 'live_view',
      },
    ],
  },
  // {
  //   title: 'Share Pixel',
  //   icon: 'ph:code-block',
  //   status: false,
  //   type: 'many',
  //   role: 'settings',
  //   name: 'website.pixel.sharePixel',
  // },
  {
    title: 'Discounts',
    icon: 'heroicons:receipt-percent',
    status: false,
    type: 'many',
    role: 'discounts',
    name: 'website.discount.code',
    children: [
      {
        title: 'Code',
        name: 'website.discount.code',
        role: 'discounts',
      },
      {
        title: 'Automatic',
        name: 'website.discount.automatic',
        role: 'discounts',
      },
    ],
  },
  // {
  //   title: 'Customers',
  //   icon: 'heroicons:users',
  //   name: 'website.customer',
  //   children: [],
  //   role: 'customers',
  //   type: 'only',
  // },
  // {
  //   title: 'Apps',
  //   icon: 'heroicons:puzzle-piece',
  //   name: 'website.apps',
  //   type: 'only',
  //   role: 'apps',
  // },
  // {
  //   title: 'Boost UpSell',
  //   icon: 'mdi:tag-arrow-up-outline',
  //   name: 'website.upsell',
  //   type: 'only',
  //   role: 'apps',
  // },
  {
    title: 'Settings',
    icon: 'heroicons:cog-6-tooth',
    name: 'website.settings',
    children: [],
    type: 'only',
    role: 'settings',
  },
  // {
  //   title: 'Payouts',
  //   icon: 'mynaui:credit-card',
  //   name: 'website.settings.payout',
  //   children: [],
  //   type: 'only',
  //   role: 'settings',
  // },
  {
    title: 'Notifications',
    icon: 'ri-telegram-line',
    name: 'website.notification',
    type: 'only',
    role: 'settings',
  },
  {
    title: 'Sales Channel',
    icon: 'iconoir:megaphone',
    name: 'website.sales-channel',
    type: 'only',
    role: 'settings',
  },
  {
    title: 'Online Store',
    icon: 'carbon:store',
    status: false,
    type: 'many',
    role: 'online_store',
    children: [
      {
        title: 'Themes',
        name: 'website.settings.themes',
        role: 'checkout',
      },
      {
        title: 'Custom Store',
        name: 'website.themes',
        role: 'online_store',
      },
      // {
      //   title: 'Custom Homepage',
      //   name: 'website.custom-homepage',
      //   role: 'online_store',
      // },
      {
        title: 'Pages',
        name: 'website.pages',
        role: 'online_store',
      },
      {
        title: 'Navigation',
        name: 'website.menus',
        role: 'online_store',
      },
      {
        title: 'Domain',
        name: 'website.domain',
        role: 'online_store',
      },
      {
        title: 'Preferences',
        name: 'website.preferences',
        role: 'online_store',
      },
      // {
      //   title: 'Member',
      //   icon: 'mdi-account-group',
      //   name: 'website.member',
      //   type: 'only',
      //   role: 'online_store',
      // },
      // {
      //   title: 'Size chart',
      //   name: 'website.sizechart',
      //   role: 'online_store',
      // },
    ],
  },
];
const menuHomePageSection = [
  {
    title: 'Catalogs',
    icon: 'system-uicons:tags',
    name: 'website.catalog',
    type: 'only',
    role: 'catalogs',
  },
  {
    title: 'Products',
    icon: 'fluent:tag-28-regular',
    name: 'website.products',
    status: false,
    type: 'many',
    role: 'products',
    children: [
      {
        title: 'All Products',
        name: 'website.products',
        role: 'products',
      },
      {
        title: 'Collections',
        name: 'website.collections',
        role: 'products',
      },
      {
        title: 'Gem Pages',
        name: 'website.products.gemPages',
        role: 'products',
      },
    ],
  },
  {
    title: 'Online Store',
    icon: 'carbon:store',
    status: false,
    type: 'many',
    role: 'online_store',
    children: [
      {
        title: 'Themes',
        name: 'website.settings.themes',
        role: 'checkout',
      },
      {
        title: 'Custom Store',
        name: 'website.themes',
        role: 'online_store',
      },
      {
        title: 'Custom Homepage',
        name: 'website.custom-homepage',
        role: 'online_store',
      },
      {
        title: 'Pages',
        name: 'website.pages',
        role: 'online_store',
      },
      {
        title: 'Navigation',
        name: 'website.menus',
        role: 'online_store',
      },
      {
        title: 'Domain',
        name: 'website.domain',
        role: 'online_store',
      },
      {
        title: 'Preferences',
        name: 'website.preferences',
        role: 'online_store',
      },
    ],
  },
];

export default {
  menu,
  dropMenu,
  podMenu,
  menuHomePageSection,
};
